import { useState } from "preact/hooks";

/** File drop target that is also a keyboard-accessible file picker. */
export function Dropzone(p: {
  label: string;
  hint: string;
  onFiles: (files: File[]) => void;
  disabled?: boolean;
  /** Less padding, for a drop target inside a page section. */
  compact?: boolean;
}) {
  const [over, setOver] = useState(false);
  const take = (list: FileList | null | undefined) => {
    const files = [...(list ?? [])];
    if (files.length > 0) {
      p.onFiles(files);
    }
  };
  return (
    // biome-ignore lint/a11y/noNoninteractiveElementInteractions: the drop target wraps the file input, which is the keyboard/screen reader path.
    <label
      class={`flex cursor-pointer flex-col items-center gap-1 rounded-lg border-2 border-dashed px-6 text-center text-sm ${p.compact ? "py-4" : "py-8"} focus-within:outline-2 focus-within:outline-blue-600 ${over ? "border-blue-500 bg-blue-50" : "border-zinc-300 bg-white hover:bg-zinc-50"}`}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        take(e.dataTransfer?.files);
      }}
    >
      <span class="font-medium text-zinc-900">{p.label}</span>
      <span class="text-zinc-500">{p.hint}</span>
      <input
        type="file"
        multiple={true}
        class="sr-only"
        disabled={p.disabled ?? false}
        onChange={(e) => {
          take(e.currentTarget.files);
          e.currentTarget.value = "";
        }}
      />
    </label>
  );
}
